// import React from 'react'
// import HighlightText from './HighlightText'
// import know_your_progress from "../../../assets/Images/Know_your_progress.png"
// import compare_with_others from "../../../assets/Images/Compare_with_others.png"
// import plan_your_lessions from "../../../assets/Images/Plan_your_lessons.png"
// import CTAButton from "../HomePage/Button"

// const LearningLanguageSection = () => {
//   return (
//     <div className='mt-[130px] mb-32'>
//          <div className='flex flex-col gap-5'>

//             <div className='text-4xl font-semibold text-center'>
//                 Your Swiss Knife for 
//                 <HighlightText text={"learning any language"} />
//             </div>
//             <div className='text-center text-richblack-600 mx-auto text-base mt-3 font-medium w-[80%]' >
//                 Using spin making learning multiple languages easy. with 20+ languages realistic voice-over,
//                 progress tracking, custom schedule and more.
//             </div>

//             <div className='flex flex-row justify-center mt-5 '>
//                <img 
//                src={know_your_progress}
//                 alt="knowYourProgressImage"
//                 className='obect-contain -mr-36'
//                />
//                <img 
//                src={compare_with_others}
//                 alt="knowYourProgressImage"
//                 className='obect-contain'
//                />
//                <img 
//                src={plan_your_lessions}
//                 alt="plan_your_lessions"
//                 className='obect-contain -ml-36'
//                />

//             </div>
            
//             <div className='w-fit mx-auto'>
//                 <CTAButton active={true} linkto={"/signup"}>
//                    <div>Learn More</div>
//                 </CTAButton>
//             </div>

//          </div>
//     </div>
//   )
// }

// export default LearningLanguageSection

























import React from 'react'
import HighlightText from './HighlightText'
import CTAButton from "../../../components/core/HomePage/Button";
import Know_your_progress from "../../../assets/Images/Know_your_progress.png";
import Compare_with_others from "../../../assets/Images/Compare_with_others.svg";
import Plan_your_lessons from "../../../assets/Images/Plan_your_lessons.svg";

const LearningLanguageSection = () => {
  return (
    <div>
        <div className="text-4xl font-semibold text-center my-10">
            Your swiss knife for
            <HighlightText text={"learning any language"} />
            <div className="text-center text-richblack-700 font-medium lg:w-[75%] mx-auto leading-6 text-base mt-3">
              Using spin making learning multiple languages easy. with 20+
              languages realistic voice-over, progress tracking, custom schedule
              and more.
            </div>
            <div className="flex flex-col lg:flex-row items-center justify-center mt-8 lg:mt-0">
              <img
                src={Know_your_progress}
                alt=""
                className="object-contain  lg:-mr-32 "
              />
              <img
                src={Compare_with_others}
                alt=""
                className="object-contain lg:-mb-10 lg:-mt-0 -mt-12"
              />
              <img
                src={Plan_your_lessons}
                alt=""
                className="object-contain  lg:-ml-36 lg:-mt-5 -mt-16"
              />
            </div>
          </div>

          <div className="w-fit mx-auto lg:mb-20 mb-8 -mt-5">
            <CTAButton active={true} linkto={"/signup"}>
              <div className="">Learn More</div>
            </CTAButton>
          </div>
    </div>
  )
}

export default LearningLanguageSection